import { REQUEST_MEAS, RECEIVE_MEAS, FAILURE_MEAS } from './constants';

/*
 * State shape
 {
    [idType]:  {
        meas : [mea object],
        fetching: boolean,
        error: string
    }
 }
 */

const meaReducer = (state = {}, action) => {
    switch (action.type) {
        case REQUEST_MEAS:
            return {
                ...state,
                [action.idType]: {
                    meas: {},
                    fetching: true,
                    error: ''
                }
            };
        case FAILURE_MEAS:
            return {
                ...state,
                [action.idType]: {
                    meas: {},
                    fetching: false,
                    error: action.response.message
                }
            };
        case RECEIVE_MEAS:
            return {
                ...state,
                [action.idType]: {
                    meas: action.response.payload,
                    fetching: false
                }
            };
        default:
            return state;
    }
};

export default meaReducer;



// WEBPACK FOOTER //
// ./src/services/mea/reducer.js